import { FC, useEffect, useState } from "react";
import { Box, Drawer, SxProps, Theme } from "@mui/material";

interface ICustomModalDrawerProps {
  isOpen: boolean;
  toggleDrawer(): void;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  containerRef?: HTMLElement | null;
  width?: string | number;
  maxWidth?: string;
}

export const NewCustomModalDrawer: FC<ICustomModalDrawerProps> = ({
  isOpen,
  toggleDrawer,
  children,
  sx = {},
  containerRef,
  width,
  maxWidth = "90vw",
}) => {
  const container = containerRef ?? undefined;
  const [animateOpen, setAnimateOpen] = useState(false);

  const getDefaultWidth = () => {
    return window.innerWidth > 1300 ? 350 : 275;
  };

  const drawerWidth = width || getDefaultWidth();

  useEffect(() => {
    if (isOpen) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setAnimateOpen(true);
        });
      });
    } else {
      setAnimateOpen(false);
    }
  }, [isOpen]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={toggleDrawer}
      container={container}
      hideBackdrop
      variant="temporary"
      transitionDuration={{ enter: 0, exit: 0 }}
      SlideProps={{ container }}
      ModalProps={{
        container,
        disablePortal: Boolean(container),
        keepMounted: true,
        disableScrollLock: true,
      }}
      PaperProps={{
        sx: {
          position: "absolute",
          right: 0,
          top: 0,
          height: "99.9%",
          width: drawerWidth,
          ...(width && { maxWidth }),
          borderRadius: 0,
          boxShadow: 3,
          backgroundColor: "#fff",
          zIndex: 2,
          transform: animateOpen ? "translateX(0)" : "translateX(100%)",
          transition: "transform 300ms ease-out",
          willChange: "transform",
        },
      }}
    >
      <Box sx={{ p: 2, ...sx }}>{children}</Box>
    </Drawer>
  );
};